import { formatPlan } from '~/assets/util/formatters'

export const state = () => {
	return {
		data: []
	}
}

export const getters = {
	plans (state) {
		return state.data
	},
	cameraFlow (state, getters) {
		return getters.active && getters.active.camera && getters.active.camera.type
	},
	active ({ data }) {
		return data[0]
	},
	isAirUser (state, getters) {
		return getters.active && getters.active.camera && getters.active.camera.type === 'air'
	},
	isActionUser (state, getters) {
		return getters.active && getters.active.camera && getters.active.camera.type === 'action'
	},
	isHaveSubscription (state) {
		return state.data.some(plan => plan.software !== undefined)
	},
	isHaveServices (state) {
		return state.data.some(plan => plan.software !== undefined && plan.software.object === 'service')
	}
}

export const actions = {
	async fetchPlans ({ commit }) {
		try {
			const { data } = await this.$axios.$get('/api/v1/payment/users/plans')

			this.$log.debug('[PlansStore] Got `plans` from API', data)
			const plans = data.map((plan) => {
				if (Object.prototype.hasOwnProperty.call(plan, 'software')) {
					plan.planName = plan.software.object === 'subscription'
						? this.$i18n.tc(`common.subscription-interval-${plan.software.intervalCount}`)
						: this.$i18n.tc(`common.service-interval-${plan.software.intervalCount}`)
					return formatPlan(plan)
				}
				return plan
			})
			commit('setPlans', plans)
		} catch (error) {
			commit('setPlans', [])
			this.$log.error('[PlansStore] Error during `fetchPlans` action', error)
		}
	},
	updatePlan ({ commit, state }, payload) {
		const planId = payload.id

		commit('updatePlanById', { id: planId, data: payload })
	}
}

export const mutations = {
	setPlans (state, plans = []) {
		state.data = plans
	},
	updatePlanById (state, { id, data }) {
		state.data = state.data.map((plan) => {
			if (plan.software && plan.software.id === id) {
				plan.software = data
			}
			return plan
		})
	}
}
